// eslint-disable-next-line import/extensions
import properties from './properties.js';

const apply = (host, prop, value) => {
	if (properties.indexOf(prop) < 0) return {};

	const autoRefresh = {
		suppressData: true,
		callback: () => host.refresh()
	};

	const notRefresh = {
		callback: () => {}
	};

	const dossierFontFamily = host.controller.model.defmts[1].props.FormattingFont.Name;

	switch (prop) {
		case 'fontFamilyTotal':
			host.savePropertyAndUpdateWidget(prop, value, notRefresh);
			host.savePropertyAndUpdateWidget(
				'dossierFontFamilyTotal',
				dossierFontFamily,
				autoRefresh
			);
			break;
		case 'fontFamilyName':
			host.savePropertyAndUpdateWidget(prop, value, notRefresh);
			host.savePropertyAndUpdateWidget(
				'dossierFontFamilyName',
				dossierFontFamily,
				autoRefresh
			);
			break;
		case 'fontFamilyLevelName':
			host.savePropertyAndUpdateWidget(prop, value, notRefresh);
			host.savePropertyAndUpdateWidget(
				'dossierFontFamilyLevelName',
				dossierFontFamily,
				autoRefresh
			);
			break;
		case 'radioForNodeColorPalettes':
			host.savePropertyAndUpdateWidget(prop, value, notRefresh);
			break;
		case 'densityMode':
			if (parseInt(host.getProperty('density')) === host.defaultDensity) {
				host.savePropertyAndUpdateWidget(prop, 'auto', autoRefresh);
			} else {
				host.savePropertyAndUpdateWidget(prop, value, autoRefresh);
			}
			break;
		case 'density':
			if (value === host.defaultDensity) {
				host.savePropertyAndUpdateWidget('densityMode', 'auto', notRefresh);
			} else {
				host.savePropertyAndUpdateWidget('densityMode', 'fixed', notRefresh);
			}
			host.savePropertyAndUpdateWidget(prop, value, autoRefresh);
			break;
		case 'isVerticalScrollEnabled':
			host.savePropertyAndUpdateWidget(prop, value, notRefresh);
			host.savePropertyAndUpdateWidget('densityMode', 'auto', autoRefresh);
			host.savePropertyAndUpdateWidget('density', host.defaultDensity, notRefresh);
			break;
		case 'dataLabelsHideableLayout':
			host.savePropertyAndUpdateWidget('showName', !value, autoRefresh);
			break;
		case 'totalHideableLayout':
			host.savePropertyAndUpdateWidget('showTotal', !value, autoRefresh);
			break;
		case 'resetCachedNodes':
			host.savePropertyAndUpdateWidget('cachedNodesOrder', JSON.stringify({}), autoRefresh);
			break;
		case 'fontSizeGlobal':
			host.savePropertyAndUpdateWidget('fontSizeTotal', value, notRefresh);
			host.savePropertyAndUpdateWidget('fontSizeName', value, notRefresh);
			host.savePropertyAndUpdateWidget('fontSizeLevelName', value, notRefresh);
			host.savePropertyAndUpdateWidget('fontSizeGlobal', value, autoRefresh);
			break;
		case 'fontFamilyGlobal':
			host.savePropertyAndUpdateWidget(
				'dossierFontFamilyGlobal',
				dossierFontFamily,
				notRefresh
			);
			host.savePropertyAndUpdateWidget(
				'dossierFontFamilyTotal',
				dossierFontFamily,
				notRefresh
			);
			host.savePropertyAndUpdateWidget(
				'dossierFontFamilyName',
				dossierFontFamily,
				notRefresh
			);
			host.savePropertyAndUpdateWidget(
				'dossierFontFamilyLevelName',
				dossierFontFamily,
				notRefresh
			);
			host.savePropertyAndUpdateWidget('fontFamilyTotal', value, notRefresh);
			host.savePropertyAndUpdateWidget('fontFamilyName', value, notRefresh);
			host.savePropertyAndUpdateWidget('fontFamilyLevelName', value, notRefresh);
			host.savePropertyAndUpdateWidget('fontFamilyGlobal', value, autoRefresh);
			break;
		case 'fontColorGlobal':
			host.savePropertyAndUpdateWidget('fontColorTotal', value, notRefresh);
			host.savePropertyAndUpdateWidget('fontColorName', value, notRefresh);
			host.savePropertyAndUpdateWidget('fontColorLevelName', value, notRefresh);
			host.savePropertyAndUpdateWidget('fontColorGlobal', value, autoRefresh);
			break;
		case 'fontStyleGlobal':
			host.savePropertyAndUpdateWidget('fontStyleName', JSON.stringify(value), notRefresh);
			host.savePropertyAndUpdateWidget('fontStyleTotal', JSON.stringify(value), notRefresh);
			host.savePropertyAndUpdateWidget(
				'fontStyleLevelName',
				JSON.stringify(value),
				notRefresh
			);
			host.savePropertyAndUpdateWidget('fontStyleGlobal', JSON.stringify(value), autoRefresh);
			break;
		case 'fontStyleName':
			host.savePropertyAndUpdateWidget('fontStyleName', JSON.stringify(value), autoRefresh);
			break;
		case 'fontStyleTotal':
			host.savePropertyAndUpdateWidget('fontStyleTotal', JSON.stringify(value), autoRefresh);
			break;
		case 'fontStyleLevelName':
			host.savePropertyAndUpdateWidget(
				'fontStyleLevelName',
				JSON.stringify(value),
				autoRefresh
			);
			break;
		case 'nodeColorPalette':
			host.savePropertyAndUpdateWidget(
				'prevThemePaletteId',
				host.model.docModel.plt.did,
				notRefresh
			);
			host.savePropertyAndUpdateWidget(prop, JSON.stringify(value), autoRefresh);
			break;
		case 'userPalette': {
			if (!value) return;
			const palette = value.split(',');
			mstrmojo.util.ui.ColorPicker.addCustomColor(palette[palette.length - 1]);
			host.savePropertyAndUpdateWidget(prop, value, notRefresh);
			break;
		}
		default:
			host.savePropertyAndUpdateWidget(prop, value, autoRefresh);
	}
};

export default apply;
